import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-consumption-place-gas',
  templateUrl: './consumption-place-gas.component.html',
  styleUrls: ['./consumption-place-gas.component.scss']
})
export class ConsumptionPlaceGasComponent implements OnInit {

  public consumptionPlaceForm: FormGroup;
  public consumptionPlaceAddress: string = "Adresa loc de consum";
  public networkOperator: string = "Operator de retea";
  public clc: string = "CLC";
  public serviceContract: string = "Modul de contractare al serviciului de retea";
  public accessToUpstreamSupplyLines: string = "Acces la conductele de alimentare din amonte";
  public contractType: string = "Tip contract";
  public contractNo: string = "Numar contract";
  public contractDate: string = "Data contract";
  public conventionType: string = "Tip conventie";
  public conventionNo: string = "Numar conventie";
  public conventionDate: string = "Data conventie";
  public conventionParties: string = "Parti conventie";
  public conventionExists: string = "Exista conventie?";
  public multipleSuppliers: string = "Exista mai multi furnizori";
  public number: string = "Numar";
  public date: string = "Data";
  public technicalConnectionApproval: string = "Aviz tehnic de racordare";
  public pressure: string = "Presiune";
  public approvedDebit: string = "Debit aprobat (mc/h)";
  public connectionType: string = "Tip racord";
  public networkType: string = "Tip retea";
  public counterType: string = "Tip contor";
  public counterSeries: string = "Serie contor";
  public intelligentMeasurementSystem: string = "Exista un sistem de masurare inteligent";
  public yes: string = "DA";
  public no: string = "NU";
  public connected: string = "Conectat";
  public disconnected: string = "Deconectat";
  public distribution: string = "Distributie";
  public transport: string = "Transport";
  public consumptionPlaceStatus: string = "Status loc de consum";
  public throughSupplier: string = "Prin furnizor";
  public directly: string = "Direct";
  public accessAgreement: string = "Acord de acces";
  public upstreamSupplyLine: string = "Conducta de alimentare din amonte";
  public consumptionCategory: string = "Categoria de consum";
  public reservedCapacity: string = "Capacitate rezervata (MWh/h)";
  public pressureCf: string = "Presiune cf. ATR (Pa)";
  public minimumPressure: string = "Presiune minima (Pa)";
  public maximumPressure: string = "Presiune maxima (Pa)";
  public minimumTechnologicalPressure: string = "Presiune minima tehnlogica (Pa)";
  public prosumerQuality: string = "Are calitatea de prosumator?";
  public indexReadingFrequency: string = "Periodicitate citire index(luni)";

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit(): void {
    this.createConsumptionForm();
  }

  createConsumptionForm(): void {
    this.consumptionPlaceForm = this.formBuilder.group({

    })
  }
}
